import React from 'react';
import './dots.scss';

const SpinnerDots = props => {
    return (
        <span className="spinner-dots">
            <span className="dot1"></span>
            <span className="dot2"></span>
            <span className="dot3"></span>
        </span>
    );
};

export default SpinnerDots;